
    import Vue from 'vue';
    import XBreadcrumb from '../components/Breadcrumb.vue';
    import XModalCancel from '@/apps/shared/components/modalCancel.vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import DateService from '@/apps/shared/utils/formatDate';
    export default Vue.extend({
        name: 'ElectronicDeviceSummary',
        components: {
            XBreadcrumb,
            XModalCancel
        },
        data() {
            return {
                effectDate: null,
                expirationDate: null,
                name: null,
                email: null,
                telephone: null,
                cover: null,
                planDescription: null,
                firstPaymentFee: null,
                capital: null,
                undiscountedPrice: null,
                rate: null,
                cupeUrl: null,
                breadcrumbItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Resumen', path: 'tecnologia/resumen' },
                ],
                product: 'tecnologia'
            }
        },
        methods: {
            changeTitleAndIcon() {
                const newTitle = 'Tecnología';
                this.$emit('updateTitle', newTitle);
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.$emit('updateByProductGoogleAnalytics', productGtmName);
            },         
            redirectToCupe() {
                NF.UI.Page.block();
                if (this.cupeUrl) {
                    sessionStorage.setItem("ExitOrContinueModal", "false");
                    window.location.href = this.cupeUrl;
                } else {
                    console.error('URL no válida');
                }
                NF.UI.Page.unblock();
            },
            getCUPE() {
                const email = "";
                const productId = 1000;
                NF.UI.Page.block();
                var timeStart = new Date().getTime();
                CUPEService.GetCUPEUrl(productId, email).then((response) => {
                    var endTime = new Date().getTime();
                    var secondCharge = Math.round((endTime - timeStart) / 1000);
                    window.globalThis.dataLayer.push({ 'product': 'tecnologia', 'event': 'cotizador-tecnologia-checkout', 'carga': secondCharge });
                    this.cupeUrl = response.preferenceMessage;
                }).catch((error) => {
                    console.error('Error al obtener la URL:', error);
                }).finally(() => {
                    NF.UI.Page.unblock();
                });
            },
            getInitData() {
                const today = new Date();
                const nextYearDate = new Date(today);
                nextYearDate.setFullYear(today.getFullYear() + 1);

                this.effectDate = DateService.formatDate(today);
                this.expirationDate = DateService.formatDate(nextYearDate);

                const coverData = sessionStorage.getItem("cover");
                const personData = sessionStorage.getItem("stepOneData");
                const planDataSelected = sessionStorage.getItem("PlanSelected");

                if (coverData != null) {
                    this.cover = JSON.parse(coverData!);
                }

                if (personData != null) {
                    const person = JSON.parse(personData!);
                    this.name = person.firstName + ' ' + person.lastName;
                    this.email = person.email;
                    this.telephone = person.areaCode + '-' + person.telephone;
                }

                if (planDataSelected != null) {
                    const dataPlan = JSON.parse(planDataSelected!);
                    this.planDescription = dataPlan.planDescription;
                    this.firstPaymentFee = dataPlan.premioMensual;
                    this.capital = dataPlan.capital;
                    this.undiscountedPrice = dataPlan.premiumWithoutDiscount;
                    NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                    DiscountRangeService.getElectronicEquipmentDiscountRange().then((response) => {
                        if (response.length > 0) {
                            this.rate = response[0].discountMaxValue;
                        }
                    }).finally(() => {
                        NF.UI.Page.unblock();
                    });
                }
            }
        },
        mounted() {
            sessionStorage.setItem("ExitOrContinueModal", "true");
            Promise.all([
                Promise.resolve(this.changeTitleAndIcon()),
                Promise.resolve(this.updateByProductGoogleAnalytics()),
                Promise.resolve(this.getInitData()),
                Promise.resolve(this.getCUPE()),
            ]);
        },
    });
